export class AppRoutingConstants
{
    public static readonly EMPTY: string = '';
    public static readonly WILDCARD: string = '**';
    public static readonly SERVER_ERROR: string = 'error';
}